module.exports = __webpack_public_path__ + "fonts/fa-brands-400.31015e8.woff2";